/**
 * Product brand — replace Ink Tide / Wave-Racer before any commercial release.
 *
 * LEGAL: upstream Wave-Racer currently ships without a LICENSE file. Do not
 * publish a commercial build until you have written permission from the
 * original author, or until this fork is a clean-room rewrite of the systems.
 */

export const BRAND = {
  id: 'ink-surge',
  name: 'INK SURGE',
  nameZh: '墨涌',
  tagline: 'Cel-shaded boat racing on a living ocean.',
  taglineZh: '水墨风海上竞速，浪尖甩尾，越涌起飞。',
  /** Shown in boot veil and store copy. */
  shortPitch: 'Three boat classes. One career cup. Endless ocean.',
} as const;
